/** Внутренняя лента уведомлений и подсказки связей. */

import type { NotificationsDto, RelationSuggestionDto } from '@project-os/contracts';
import { useQuery } from '@tanstack/react-query';
import { apiRequest } from './client';

export const notificationKeys = {
  feed: (projectId: string) => ['projects', projectId, 'notifications'] as const,
  suggestions: (projectId: string, itemId: string) =>
    ['projects', projectId, 'items', itemId, 'suggestions'] as const,
};

/**
 * Лента уведомлений.
 *
 * Обновляется раз в минуту: уведомления выводятся из состояния проекта, и
 * чаще спрашивать бессмысленно — срок не наступит за десять секунд. Опрос
 * останавливается, когда вкладка не видна.
 */
export function useNotifications(projectId: string | undefined) {
  return useQuery({
    queryKey: notificationKeys.feed(projectId ?? ''),
    queryFn: ({ signal }) =>
      apiRequest<NotificationsDto>(`/projects/${projectId}/notifications`, { signal }),
    enabled: Boolean(projectId),
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    staleTime: 30_000,
  });
}

/** Подсказки связей для элемента. Запрашиваются только когда их показывают. */
export function useRelationSuggestions(projectId: string, itemId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: notificationKeys.suggestions(projectId, itemId ?? ''),
    queryFn: ({ signal }) =>
      apiRequest<RelationSuggestionDto[]>(`/projects/${projectId}/items/${itemId}/suggestions`, {
        signal,
      }),
    enabled: enabled && Boolean(itemId),
    staleTime: 60_000,
  });
}
